import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import sanitizeHtml from 'sanitize-html';
import { plainTextNoHTML } from 'config/sanitizeHTML';

//  Search engines should not show a cached link to the page on a SERP.
const metaRobotsNoarchive = <meta name="robots" content="noarchive" />;

const Meta = ({ metaTags, title }) => {
  const metaTitle = metaTags.find((tag) => 'title' === tag.name);
  const metaTitleContent = metaTitle && metaTitle.content;
  let containsRobots = false;

  return (
    <Helmet>
      <title>{metaTitleContent || title}</title>
      {/* eslint-disable react/no-array-index-key */}
      {/* These meta tags do not have an obvious id, but they also don't
        change, and they are never reordered, so an index key will
        be safe in this situation. */}
      {metaTags.map(({ name, content }, idx) => {
        // Special exception for OpenGraph tags improperly using the property attribute instead of name
        let updatedContent = content;
        if ('robots' === name) {
          // If content field does not contain archive or noarchive, add noarchive
          if (-1 === updatedContent.search('archive')) {
            updatedContent = content.concat(', ', 'noarchive');
          }
          containsRobots = true;
        }

        return (
          /^(og|fb):/.test(name) ?
            <meta
              key={`${name}${idx}`}
              property={name}
              content={sanitizeHtml(updatedContent, plainTextNoHTML)}
            />
            :
            <meta
              key={`${name}${idx}`}
              name={name}
              content={sanitizeHtml(updatedContent, plainTextNoHTML)}
            />
        );
      })}
      {containsRobots ? null : metaRobotsNoarchive}
      {/* eslint-enable react/no-array-index-key */}
    </Helmet>
  );
};

Meta.propTypes = {
  metaTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
  title: PropTypes.string,
};

Meta.defaultProps = {
  metaTags: [],
  title: 'Babbel Magazine',
};

export default Meta;
